import React, { Component } from 'react';
import {ref} from '../../config/firebase';

export default class Education extends Component {
	constructor(props) {
		super(props);
		this.state = {
			items: []
		};

		this.dbItems = ref.child('education');
	}

	componentDidMount() {
		this.dbItems.on("value", snapshot => {
			var items = [];


			snapshot.forEach(function(childSnapshot) {

				var item = childSnapshot.val();

				item['.key'] = childSnapshot.key;

				items.push(item);

			});

			this.setState({items});

		});

	}

  render() {
    return (

      	<div className="container">
			<div className="row pt50 pb50">
				<div className="col-md-12">
					<h2 className="white uppercase pb20"><i className="fa fa-mortar-board"></i> Education</h2>
				</div>
				{
					this.state.items.map(function(item) {

						return (
							<div className="col-md-4 col-sm-6 text-center" key={item['.key']}>
								<div className="panel panel-warning">
									<div className="panel-heading">
										<p className="black bold uppercase pt10"><i className="fa fa-clock-o"></i> {item.period}</p>
										<p className="black bold uppercase"><i className="fa fa-mortar-board"></i> {item.major}</p>

									</div>
									<div className="panel-body">
										<p className="text-left"><b>Achievement:</b></p>
										{
											item.achievement.split(";").map(i => {
												return (
													<p className="text-left" key={Math.random()}>
														<i className="fa fa-caret-right"></i> {i}
													</p>
												);
											})
										}
									</div>
									<div className="panel-footer"><a className="black" href={item.link} target="_blank" rel="noopener noreferrer"><i className="fa fa-university"></i> {item.place}</a></div>
								</div>
							</div>
						);
					})
				}

			</div>
		</div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/guest/components/Education.js